import { Link } from "react-router-dom";
import { Receipt } from "lucide-react";
import { btwHint, btwRegime } from "@/lib/btw";

// Kleine badge die de invoerconventie toont (incl./excl. BTW); klikt door naar het BTW-tabblad van de club.
export function BtwHint({ club, clubId, testid = "btw-hint" }) {
  if (!club) return null;
  const plichtig = btwRegime(club) !== "vrijgesteld";
  const cls = `inline-flex items-center gap-1.5 border-2 border-foreground/30 px-2 py-1 text-[10px] font-display uppercase font-bold tracking-wider ${plichtig ? "bg-secondary/10 text-foreground" : "bg-muted text-muted-foreground"} hover:border-foreground transition-colors`;
  const inner = <><Receipt className="w-3 h-3" /> {btwHint(club)}</>;
  const id = clubId || club.id;
  return id
    ? <Link to={`/clubs/${id}?tab=btw`} className={cls} data-testid={testid} title="BTW-instelling van de club wijzigen">{inner}</Link>
    : <span className={cls} data-testid={testid}>{inner}</span>;
}
